import { ThemeDefinition, VuetifyOptions } from 'vuetify';

const blackColor = '#212121';
const primaryVioletColor = '#073855';
const brandRedColor = '#E40613';
const whiteColor = '#FFFFFF';

const grey500Color = '#979797';
const grey300Color = '#BFBFBF';
const grey200Color = '#D4D4D4';

const polandLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    // vuetify colors
    error: '#E53935',
    info: '#2196F3',
    primary: primaryVioletColor,
    secondary: whiteColor,
    success: '#388E3C',
    warning: '#FB8C00',
    background: grey200Color,
    'on-surface': blackColor,
    'on-background': blackColor,

    // custom colors
    contrast: blackColor,
    systemPrimary: brandRedColor,
    systemToolbar: brandRedColor,
    navigationDrawer: brandRedColor,
    neutral: grey500Color,
    'neutral-light': whiteColor,
    'neutral-border': grey300Color,
    'on-navigationDrawer': '#4A4A4A',
    'on-systemToolbar': whiteColor,
  },
};

export const polandTheme: VuetifyOptions['theme'] = {
  defaultTheme: 'light',
  themes: {
    light: polandLightTheme,
  },
};
